<script lang="ts">
  import PostCard from '$lib/components/shared/PostCard.svelte'
  import SvelteSeo from 'svelte-seo'
  import type { PageData } from './$types'

  export let data: PageData

  $: posts = data.posts
  $: title = data.title
  $: description = data.description
</script>

<SvelteSeo
  twitter={{
    description,
    title,
    site: '@airheartinc',
  }}
  openGraph={{
    title,
    description,
  }}
/>

<main class="max-w-4xl pb-16 pt-8 m-4 sm:m-auto col-span-12">
  <div
    class="grid gap-4 pt-12 md:grid-cols-2 md:gap-x-0 md:gap-y-4 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-12"
  >
    {#each posts as post (post.slug)}
      <PostCard {post} />
    {/each}
  </div>
</main>
